module.exports = __webpack_public_path__ + "img/jordan.b441ef43.png";